const DEFAULTS = {
  greyscale: 0,
  blur: 0,
  sepia: 0,
  saturate: 100,
  opacity: 100,
  brightness: 100,
  contrast: 100,
  hue: 0,
  invert: 0,
};
export default DEFAULTS;
